// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + "excel-worker" + "." + "9c9895ab" + ".chunk.js";
};